import * as angular from "angular";
import {IController} from "angular";

export class PlanningProjectSettingsSectionCtrl implements IController {

  settings: any;
  draftName: any;
  project?: any;
  draft?: any;
  depots: any;
  onSave: Function;
  onSaveAndReoptimize: Function;

  constructor() {
  }

  $onInit() {
    if (this.draft && !this.draft.clusteringAreaIds) {
      this.draft.clusteringAreaIds = [];
    }
  }

  onDraftNameChange(draftName) {
    this.draftName = draftName;
  }

  onSettingsChange(updatedSettings) {
    this.settings = updatedSettings;
  }

  onDraftChange(draft) {
    if (this.draft) {
      this.draft.clusteringAreaIds = draft.clusteringAreaIds;
    }
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningProjectSettingsSection', {
    bindings: {
      settings: '<',
      draftName: '<',
      project: '<?',
      draft: '<?',
      depots: '<?',
      onSave: '&',
      onSaveAndReoptimize: '&'
    },
    template: require('./planning-project-settings-section.html').default,
    controller: PlanningProjectSettingsSectionCtrl
  });
